import { ReactElement } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { StrapiMenuPage } from '../../core/models/strapi-menu-page.model';
import './FooterMenu.scss';

export type FooterMenuProps = {
  menuPages: Array<StrapiMenuPage>;
  title: string;
};

export const FooterMenu = ({ menuPages, title }: FooterMenuProps): ReactElement => (
  <Grid size={{ xs: 6, sm: 4, md: 2 }} className='footer-menu'>
    <h6>{title}</h6>
    <ul>
      {[...menuPages]
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((item) => (
          <li key={item.id}>
            <Link to={`/content/${item.urlSegment}`}>{item.title}</Link>
          </li>
        ))}
    </ul>
  </Grid>
);
